// This is just an example,
// so you can safely delete all default props below

export default {
    signup: 'Sign Up',
    signup_desc: 'Description goes to here',
    given_name: 'First Name',
    family_name: 'Last Name',
    address_line_1: 'Address',
    postal_code: 'Postal Code',
    locality: 'City',
    country_code: 'Country',
    phone_number: 'Phone Number',
    email: 'Email',
    email_repeat: 'Repeat Email',
    password: 'Password',
    password_repeat: 'Repeat Password',
    error_given_name: 'First name must be supplied',
    error_family_name: 'Last name must be supplied',
    error_address_line_1: 'Address must be supplied',
    error_postal_code: 'Postal code must be supplied',
    error_locality: 'City must be supplied',
    error_country_code: 'Country must be supplied',
    error_phone_number: 'Phone number is not valid',
    error_email: 'Email is not valid',
    error_email_repeat: 'Email repeated must be the same with email',
    error_password: 'Password must be at least 8 characters long and contain at least one uppercase character one lowercase character and one number',
    error_password_repeat: 'Password repeated must be the same with password',
    error_email_exist: 'Email is already in use',
    signup_success: 'Signup Success',
    signup_success_desc: 'Your account has been created successfully.'
}
